Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isPlainObject = require('prop-types-exact/build/helpers/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _isPlainObject2['default'];
//# sourceMappingURL=isPlainObject.js.map